<script setup lang="ts">
import { RouterView } from 'vue-router'
</script>

<template>
  <div class="min-h-screen w-full flex items-center justify-center bg-gray-50">
    <RouterView />
  </div>
</template>
